import React from "react";
import "./forgetPassword.css";
import ForgetPass from "./ForgetPass.png";
import logo from "./logo.png";
import { MdOutlineAlternateEmail } from "react-icons/md";
import { HiUserCircle } from "react-icons/hi";
const ForgetPassword = () => {

  return (
    <>
     <div className="wholeLogin">
      <div className="login-header-logo">
        <img src={logo} alt="image error" />
        {/* <DarkMode className="darkIcon" /> */}
      </div>{" "}
      <div className="ForgetContainer container-fluid">
        <div className="Login-Left-Side">
          <img src={ForgetPass} alt="error" />
        </div>{" "}
        <div className="Forget-Right-Side container ">
          <div className="ForgetContent container">
            <h1
              style={{
                fontFamily: "Itim",

                fontWeight: "400",
                fontStyle: "normal",
              }}
            >
              {" "}
              Forget Password{" "}
            </h1>{" "}
            <p style={{ fontSize: "20px" }}>
              Enter Username, Email or Phone Number
            </p>{" "}
          </div>{" "}
          <form className="login-form container">
            <div className="textbox">
              <input
                type="text"
                placeholder="Enter Username, Email or Phone Number"
                className="input"
              />
              <span>
                {" "}
                <MdOutlineAlternateEmail
                  style={{
                    fontSize: "25px",
                  }}
                  id="emailIcon-Forget"
                />
              </span>
            </div>{" "}
            <div className="Submit-Btn   ">
              <button type="submit" className="hvr-bounce-to-bottom">
                Confirm
              </button>{" "}
            </div>{" "}
          </form>{" "}
          <div className="login_icon">
            <p className="have-account">
              {" "}
              Already have an account ? <a href="#"> Log in </a>
            </p>{" "}
          </div>
        </div>{" "}
      </div>{" "}
      </div>
    </>
  );
};
export default ForgetPassword;
